import { ArrowRight } from '@/components/ui/icons'
import { Link } from '@/i18n/navigation'

// One CTA pair for the whole page: start for free, and a secondary button to pricing (where the
// Enterprise contact lives). The hero keeps its own sign-up modal path.
export const ACCESS_FORM_URL = 'https://form.typeform.com/to/VVwyeUrj'

export function CtaButtons({ className = '', size = 'md' }: { className?: string; size?: 'md' | 'lg' }) {
  const h = size === 'lg' ? 'h-14 px-8 text-[17px]' : 'h-12 px-6 text-[15px]'
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      <a
        href={ACCESS_FORM_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-cta="start_for_free"
        className={`group inline-flex items-center gap-2.5 rounded-xl bg-white font-semibold text-black transition-colors hover:bg-white/90 ${h}`}
      >
        Get started
        <ArrowRight className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" />
      </a>
      <Link
        href="/pricing"
        data-cta="see_pricing"
        className={`inline-flex items-center rounded-xl border border-white/15 font-medium text-white/80 transition-colors hover:border-white/30 hover:text-white ${h}`}
      >
        See pricing
      </Link>
    </div>
  )
}
